import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRemoteUICopy } from './copy.js';
import { useEffect, useState } from 'react';
export function AgentActivityStatus({ state, disabled, commandPending = false }) {
    const copy = useRemoteUICopy();
    const agent = state.agent;
    const terminal = agent?.status === 'failed' || agent?.status === 'closed';
    const active = Boolean(agent?.activeTurn) && !terminal;
    const working = !terminal && (active || agent?.status === 'running');
    const waiting = !terminal && (state.pendingInteractions.length > 0 || agent?.status === 'waiting');
    const label = disabled ? copy.connectionUnavailable
        : agent?.status === 'failed' ? copy.agentFailed
            : agent?.status === 'closed' ? copy.runtimeStatus('closed')
                : waiting ? copy.runtimeStatus('waiting')
                    : working ? copy.runtimeStatus('running')
                        : commandPending ? copy.executingCommand
                            : agent?.status === 'starting' ? copy.runtimeStatus('starting') : copy.runtimeStatus('idle');
    const timestamp = agent?.activeTurn?.startedAt;
    const startedAt = typeof timestamp === 'string' ? Date.parse(timestamp) : NaN;
    const timed = active && !disabled && Number.isFinite(startedAt);
    const [now, setNow] = useState(Date.now);
    useEffect(() => {
        setNow(Date.now());
        if (!timed)
            return;
        const interval = setInterval(() => setNow(Date.now()), 1_000);
        return () => clearInterval(interval);
    }, [agent?.id, agent?.activeTurn?.turnId, startedAt, timed]);
    const seconds = Math.max(0, Math.floor((now - startedAt) / 1_000));
    return _jsx("div", { className: "agent-activity", "data-active": disabled || terminal || working || waiting || commandPending || agent?.status === 'starting', "aria-label": copy.agentActivity, "data-testid": "agent-activity", children: _jsxs("div", { className: "agent-activity-summary", children: [_jsx("span", { className: `agent-presence agent-state-${disabled ? 'offline' : terminal ? agent?.status : waiting ? 'waiting' : working ? 'running' : 'idle'}`, "aria-hidden": "true" }), _jsx("span", { "data-testid": "agent-activity-label", "aria-live": "polite", children: label }), timed ? _jsx("time", { className: "agent-activity-elapsed", "data-testid": "turn-elapsed", "aria-label": copy.turnElapsedTime, "aria-live": "off", dateTime: `PT${seconds}S`, children: copy.elapsedTime(seconds) }) : null] }) });
}
//# sourceMappingURL=AgentActivityStatus.js.map